import React, { useRef } from 'react';
import CanvasDraw from 'react-canvas-draw';
import { Modal, Button, Spin, Space, Form } from 'antd';
import {
  LoadingOutlined,
} from '@ant-design/icons';
import Alerts from '../../components/alerts/Alerts';
import { connect } from 'react-redux';
import { CLEAR_ERRORS, FETCH_ERRORS } from '../../state/error/types';
import { RESOURCE } from '../../config/constants/alerts';
import PropTypes from 'prop-types';

const spinnerIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />;

const ModalSignContract = ({ ...props }) => {

  const [form] = Form.useForm();
  const refCanvas = useRef(null);

  const clearDraw = () => {
    refCanvas.current.clear();
  };

  const createSign = () => {
    const canvas = refCanvas.current.getSaveData();
    const image = refCanvas.current.canvasContainer.children[1].toDataURL();
    const formatedb64 = image.replace('data:image/png;base64,', '');
    try {
      const drawingObject = JSON.parse(canvas);
      if (drawingObject.lines && drawingObject.lines[0]) {
        props.onCreate(formatedb64);
      } else {
        props.drawError();
      }
    } catch { props.drawError(); }
  };

  return (
    <Modal
      className="modal-sign"
      visible={props.visible}
      title="Aprobación de contrato de arriendo"
      closable={true}
      maskClosable={false}
      centered={true}
      onCancel={props.onCancel}
      afterClose={() => props.clearErrors()}
      footer={
        <Space>
          <Button type="default" onClick={clearDraw} disabled={props.spinning}>
            Borrar Firma
          </Button>
          <Button
            type="primary"
            disabled={props.spinning}
            onClick={
              () => {
                form
                  .validateFields()
                  .then(() => {
                    createSign();
                  });
              }
            }
          >
            Validar
          </Button>
        </Space>
      }
    >
      <Spin
        spinning={props.spinning}
        size="large"
        indicator={spinnerIcon}
      >
        <Alerts />
        <p>Dibuje con el precursor del mouse o el dedo su firma</p>
        <CanvasDraw
          className='canvas-draw'
          brushRadius={0.5}
          hideGrid={true}
          canvasWidth={450}
          canvasHeight={450}
          ref={refCanvas}
        />
      </Spin>
    </Modal>
  );
};

ModalSignContract.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  spinning: PropTypes.bool.isRequired,
  spinnerIcon: PropTypes.object.isRequired,
  drawError: PropTypes.func.isRequired,
};

const action = (dispatch) => ({
  drawError: () => dispatch({ type: FETCH_ERRORS, payload: { status: 500, resource: RESOURCE.NOT_SIGN_CONTRACT } }),
  clearErrors: () => dispatch({ type: CLEAR_ERRORS }),
});

export default connect(null, action)(ModalSignContract);